import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SidebarContent } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/sidebar-content/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-global-settings-apps-settings" */ './main'
		),
);

const AsyncSidebar = () => {
	return (
		<SidebarBoundary
			id="nav4.sidebar.global-settings.apps-settings"
			packageName="jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
			ufoName="nav4.sidebar.global-settings.apps-settings"
		>
			<SidebarContent
				currentPageName="apps"
				testId="navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
			>
				<Placeholder name="nav4.sidebar.global-settings.apps-settings" fallback={<Skeleton />}>
					<LazySidebarContent />
				</Placeholder>
			</SidebarContent>
		</SidebarBoundary>
	);
};

export default memo(AsyncSidebar);
